<!-- 搜索栏 -->
<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    // 接收来自外部的value
    modelValue: {
      type: String,
      default: ''
    }
  });
  const emits = defineEmits(['update:modelValue', 'onSearch']); // 在此声明组件可以触发的事件

  const inputVal = computed({
    get: () => props.modelValue,
    set: val => {
      emits('update:modelValue', val);
    }
  });

  // 定义搜索函数
  const handleSearch = () => {
    emits('onSearch', inputVal.value); // 发射搜索事件给父组件
  };
</script>
<template>
  <el-input
    v-model="inputVal"
    size="large"
    placeholder="请输入关键字查询"
    class="input-search"
    @keyup.enter="handleSearch"
  >
    <template #append>
      <el-button @click="handleSearch"><i class="fa fa-search fa-lg"></i></el-button>
    </template>
  </el-input>
</template>
<style scope>
  .input-search {
    width: 100%;
    min-width: 220px;
    max-width: 520px;
    text-align: left;
  }
</style>
